import { render, staticRenderFns } from "./RecipientRegisterAlertMessage.vue?vue&type=template&id=7e50ee28"
import script from "./RecipientRegisterAlertMessage.vue?vue&type=script&lang=js"
export * from "./RecipientRegisterAlertMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports